/**
 * PasswordInput — Themed password field with show/hide toggle.
 *
 * Props:
 *   value, onChange, error, disabled, label, placeholder
 */
import React, { useState } from 'react';
import { useTheme } from '../../theme/ThemeContext';

export default function PasswordInput({
  value,
  onChange,
  error,
  disabled,
  label = 'Password',
  placeholder = 'Enter password',
}) {
  const { theme } = useTheme();
  const isDark = theme.auth.containerBg === '#111827';
  const [show, setShow] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div style={{ marginBottom: 12 }}>
      <label style={{ display: 'block', marginBottom: 4, fontWeight: 600, fontSize: 12, color: theme.auth.labelColor, letterSpacing: '0.2px' }}>
        {label}
      </label>
      <div style={{ position: 'relative' }}>
        <input
          type={show ? 'text' : 'password'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          disabled={disabled}
          placeholder={placeholder}
          autoComplete="new-password"
          style={{
            width: '100%',
            padding: '10px 40px 10px 12px',
            fontSize: 14,
            fontWeight: 500,
            border: `2px solid ${error ? (isDark ? 'rgba(220, 38, 38, 0.5)' : 'rgba(192, 57, 43, 0.35)') : isFocused ? (isDark ? 'rgba(13, 148, 136, 0.6)' : 'rgba(15, 118, 110, 0.5)') : (isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)')}`,
            borderRadius: 10,
            boxSizing: 'border-box',
            background: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
            color: theme.auth.inputText,
            opacity: disabled ? 0.6 : 1,
            transition: 'all 0.2s ease',
            outline: 'none',
            boxShadow: isFocused ? (isDark ? 'inset 0 1px 3px rgba(13, 148, 136, 0.1)' : 'inset 0 1px 3px rgba(15, 118, 110, 0.08)') : 'none'
          }}
        />
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setShow((s) => !s)}
          style={{
            position: 'absolute',
            right: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 12,
            fontWeight: 600,
            color: isDark ? '#2dd4bf' : '#0f766e',
            padding: '4px 6px',
            transition: 'color 0.2s ease',
          }}
          onMouseEnter={(e) => (e.target.style.color = isDark ? '#5eead4' : '#14b8a6')}
          onMouseLeave={(e) => (e.target.style.color = isDark ? '#2dd4bf' : '#0f766e')}
        >
          {show ? 'Hide' : 'Show'}
        </button>
      </div>
      {error ? (
        <div role="alert" style={{ color: isDark ? '#FF8A80' : '#8B3A2F', fontSize: 12, marginTop: 4, fontWeight: 500 }}>{error}</div>
      ) : null}
    </div>
  );
}
